// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + ({"372":"svdialog","995":"tablesorter-plugins","1602":"calendar-plugins","3138":"comments2-plugins","4510":"slideshow-plugins","5943":"rating-plugins","6172":"imagealbum-plugins","6755":"tab-plugins","6856":"archive-plugins","7409":"popover-plugins","8365":"jcrop"}[chunkId] || chunkId) + ".css";
};